import React from 'react';
import PropTypes from 'prop-types';
import { Route, useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import Layout from './Layout';
import LayoutWithSwoosh from './LayoutWithSwoosh';
import LayoutWithStickyHeader from './LayoutWithStickyHeader';
import './scss/LayoutRoute.scss';

const LayoutRouteContent = ({ ComponentToRender, withConstellation, withFooter, withHeader, LayoutComponent }) => {
    const match = useRouteMatch();
    const location = useLocation();
    const history = useHistory();

    return (
        <LayoutComponent
            component={ComponentToRender}
            withConstellation={withConstellation}
            withFooter={withFooter}
            withHeader={withHeader}
            match={match}
            location={location}
            history={history}
        />
    );
};

const LayoutRoute = ({
    component: Component,
    children,
    withConstellation,
    withFooter,
    withHeader,
    withStickyHeader,
    withSwoosh,
    ...props
}) => {
    let LayoutComponent = Layout;
    if (withSwoosh) {
        LayoutComponent = LayoutWithSwoosh;
    }
    if (withStickyHeader) {
        LayoutComponent = LayoutWithStickyHeader;
    }

    // Support both component prop (legacy) and children (v5.1 style)
    const ComponentToRender = Component || children?.type;

    return (
        <Route {...props}>
            <LayoutRouteContent
                ComponentToRender={ComponentToRender}
                withConstellation={withConstellation}
                withFooter={withFooter}
                withHeader={withHeader}
                LayoutComponent={LayoutComponent}
            />
        </Route>
    );
};

LayoutRoute.defaultProps = {
    withConstellation: true,
    withFooter: true,
    withHeader: true,
    withStickyHeader: false,
    withSwoosh: false,
};

LayoutRoute.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    children: PropTypes.element,
    withConstellation: PropTypes.bool,
    withFooter: PropTypes.bool,
    withHeader: PropTypes.bool,
    withStickyHeader: PropTypes.bool,
    withSwoosh: PropTypes.bool,
};

export default LayoutRoute;
